import React, { useState, useEffect, useRef } from "react";



const ConfirmDeletionWithUserInput = ({ HeadingTop, Heading, closeButtonClick, onYesClick }) => {

  const [randomText, setRandomText] = useState("DELETE");
  const [showDeleteButton, setShowDeleteButton] = useState(false);
  const [userText, setUserText] = useState("");
  const userTextRef = useRef(null);

  function getRandomText() {
    const texts = [
      "How are you today?",
      "Keep pushing forward!",
      "Success is near!",
      "Stay positive!",
      "Believe in yourself!",
      "Never give up!"
    ];

    const randomIndex = Math.floor(Math.random() * texts.length);

    if (randomIndex < 0 || randomIndex >= texts.length) {
      return texts[0];
    }

    return texts[randomIndex];
  }

  useEffect(() => {

    const randomText = getRandomText();
    setRandomText(randomText);

  }, [])

  function handleUserTextChange(e){

    setUserText(e.target.value);
  }

  function handleCheck(){

    let bool = randomText === userText;


    if(userTextRef.current){
      if(bool){
        userTextRef.current.style.border = '2px solid green';
      }else{
        userTextRef.current.style.border = '2px solid red';
      }
    }
    setShowDeleteButton(bool);
  }

  return (
    <div className="modal-back">
      <div className="alert-card">
        <div className="content">
          <span className="alert-title">{HeadingTop}</span>
          <div className="desc">{Heading}</div>


          <div className="ConfirmDeletionWithUserInput-captcha-container">

            <div className="ConfirmDeletionWithUserInput-captcha-text">{randomText}</div>
            <div className="ConfirmDeletionWithUserInput-captcha-input-div">
              <input ref={userTextRef} onChange={handleUserTextChange} value={userText} type="text" placeholder="Type Above Text Here!" />
              <button onClick={handleCheck}>check</button>
            </div>

          </div>

          {showDeleteButton && (

            <div style={{ textAlign: "center" }} className="action">
              <div onClick={onYesClick} className="download">
                Yes
              </div>
            </div>
          )}


        </div>
        <button
          className="alert-close"
          type="button"
          onClick={closeButtonClick}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              clip-rule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              fill-rule="evenodd"
            ></path>
          </svg>
        </button>
      </div>
    </div>
  );
};

export default ConfirmDeletionWithUserInput;
